// extracted by mini-css-extract-plugin
module.exports = {"icon":"_-ui-common-lib-icon-index-module__icon--2g2WH"};